import PreviewComponent from './preview';

let $vm;
export default {
  install(Vue) {
    const Preview = Vue.extend(PreviewComponent);

    if (!$vm) {
      $vm = new Preview({ el: document.createElement('div') });
      document.body.appendChild($vm.$el);
    }
    const preview = {
      open(index, list, params) {
        $vm.open(index, list, params);
      },
      close() {
        $vm.close();
      }
    };
    Vue.$preview = preview;
    Vue.mixin({
      created() {
        this.$preview = Vue.$preview;
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/preview/index.js